module.exports = __webpack_public_path__ + "static/media/nav_back.c7ae509e.svg";